export type WorkspaceChrome = 'iconBar' | 'menuBar';

export const WORKSPACE_CHROME_STORAGE_KEY = 'workspaceChrome';

export function readWorkspaceChrome(): WorkspaceChrome {
  const saved = localStorage.getItem(WORKSPACE_CHROME_STORAGE_KEY);
  if (saved === 'menuBar') return 'menuBar';
  return 'iconBar';
}

export function writeWorkspaceChrome(value: WorkspaceChrome): void {
  localStorage.setItem(WORKSPACE_CHROME_STORAGE_KEY, value);
}
